import { render, staticRenderFns } from "./scene-stress.vue?vue&type=template&id=44386ba5&scoped=true&"
import script from "./scene-stress.vue?vue&type=script&lang=js&"
export * from "./scene-stress.vue?vue&type=script&lang=js&"
import style0 from "./scene-stress.vue?vue&type=style&index=0&id=44386ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44386ba5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44386ba5')) {
      api.createRecord('44386ba5', component.options)
    } else {
      api.reload('44386ba5', component.options)
    }
    module.hot.accept("./scene-stress.vue?vue&type=template&id=44386ba5&scoped=true&", function () {
      api.rerender('44386ba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-stress.vue"
export default component.exports